import { useState } from "react";
import type { CallBackProps } from "react-joyride";

export function useUserPageTour() {
  const [runTour, setRunTour] = useState(false);
  const [tourStepIndex, setTourStepIndex] = useState(0);

  const handleJoyrideCallback = (data: CallBackProps) => {
    const { status, action, index, type } = data;
    const finishedStatuses = ["finished", "skipped"];

    if (action === "prev" && type === "step:after") {
      setTourStepIndex(index - 1);
      return;
    }
    if (action === "next" && type === "step:after") {
      setTourStepIndex(index + 1);
      return;
    }
    if (finishedStatuses.includes(status as string) || action === "close") {
      setRunTour(false);
      setTourStepIndex(0);
    }
  };

  return { runTour, setRunTour, tourStepIndex, handleJoyrideCallback };
}
